import React, { useState, useEffect } from "react";
import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { Table, TableColumn } from "../../../components/table";
import { UploadOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { any } from "prop-types";
import { getLocalUrl } from "../../../functions";
import { getFileHostUrl } from "../../../helpers/functions";

import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  Space,
  Button,
  Upload,
  Pagination,
} from "antd";

import "../../../assets/styles/admin/agencyList.scss";
import { Icon } from "@iconify/react";
import CountryPhoneInput, {
  CountryPhoneInputValue,
  ConfigProvider,
} from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";

const AgencyList = () => {
  const { confirm } = Modal;
  let [formAgencyList] = Form.useForm();
  const { TextArea } = Input;
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const [agencies, setAgencies] = useState<any>([]);
  const [agencyId, setAgencyId] = useState("");
  const [option, setOption] = useState([]);

  const [isDisabled, setDisabled] = useState(false);

  const [contactFile, setContactFile] = useState<any>([]);
  const [copyOfBankAccfile, setCopyOfBankAccFile] = useState<any>([]);

  const [type, setType] = useState("");
  const [optBanks, setOptBanks] = useState<any>([]);
  const [optAgentype, setOptAgencyType] = useState<any>([]);
  const [idData, setIdData] = useState("");
  const [pages, setPages] = useState(1);
  const [countPages, setCountPages] = useState(1);
  const { Option } = Select;
  const [value1, setValue1] = useState<CountryPhoneInputValue>({ short: "TH" });
  const [valuePhone1, setPhoneValue1] = useState<any>({});

  const columns = [
    {
      title: "",
    },
    {
      title: "Code",
      align: "center",
    },
    {
      title: "Agency Type",
      align: "center",
    },
    {
      title: "Name",
    },
    {
      title: "Tel.",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      colspan: 3,
    },
  ];

  function onClose() {
    setIsOpen(false);
  }

  const getDataTypes = () => {
    axios.get(`/agency-types`).then((res) => {
      let data = res?.data?.data.map((x: any) => ({
        value: x._id,
        name: x.name,
      }));
      console.log("data =>", data);
      setOption(data);
    });
  };

  const getData = async () => {
    await axios.get(`/agencies?page=${pages}`).then((res) => {
      console.log("res.data.data =>", res?.data?.data);
      setAgencies(res?.data?.data);
    });
  };

  const setAgencyTypes = async () => {
    const AgenType = await axios.get(`/agency-types`);
    const cateOptionAgency = [];

    for (let i = 0; i < AgenType?.data?.data.length; i++) {
      cateOptionAgency.push(
        <Option
          value={AgenType?.data?.data[i]?._id}
          key={AgenType?.data?.data[i]?._id}
        >
          {AgenType?.data?.data[i]?.name}
        </Option>
      );
    }
    setOptAgencyType(cateOptionAgency);
  };
  const setBankName = async () => {
    // await axios.get(`/banks`).then((res) => {
    //   console.log("res.data.data banks =>", res.data.data);
    //   setOptBanks(res.data.data);
    // });
    const Bank = await axios.get(`/banks`);
    const BankName = [];
    console.log("banks", Bank?.data?.data);

    for (let i = 0; i < Bank?.data?.data.length; i++) {
      // console.log("test", Bank?.data?.data[i]?._id);
      BankName.push(
        <Option
          value={Bank?.data?.data[i]?.name}
          key={Bank?.data?.data[i]?._id}
        >
          {Bank?.data?.data[i]?.name}
        </Option>
      );
    }
    setOptBanks(BankName);
  };

  const creatData = async (values: any) => {
    const xDatas = values;

    console.log("xDatas", xDatas);
    console.log("valuePhone1", valuePhone1);

    console.log("contact file", contactFile);
    console.log("copy file", copyOfBankAccfile);

    try {
      const data = await axios.post(`/agencies`, {
        code: xDatas?.code,
        name: xDatas?.name,
        agencyType: xDatas?.agencyType,
        // phoneNumber: xDatas?.phoneNumber,
        phoneNumbersFirst: valuePhone1,
        taxpayerNumber: xDatas?.taxpayerNumber,
        bankAccount: xDatas?.bankAccount,
        bankAccountNumber: xDatas?.bankAccountNumber,
        // copyOfBankAccount: "",
        // contractDocument: "",
        address: xDatas?.address,
      });
      const _id = data?.data?._id;
      // console.log("data", data);
      // if (xDatas?.contractDocument) {
      const fmData = new FormData();
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      fmData.append(
        "contractDocument",
        xDatas?.contractDocument?.fileList[0]?.originFileObj
      );
      fmData.append(
        "copyOfBankAccount",
        xDatas?.copyOfBankAccount?.fileList[0]?.originFileObj
      );
      // console.log("_id", data?.data?._id);
      await axios.patch(`/agencies/upload-file/${_id}`, fmData, config);
      // _id = data
      // .then((res) => {
      //     setTimeout(() => getData(), 200);
      //     setIsOpen(false);
      //   });
      // console.log("valus", value);
      // }
      setIsOpen(false);
      getData();
      formAgencyList.resetFields();
    } catch (error) {
      console.log("error", error);
    }
  };
  const getDataOne = (id: any) => {
    axios.get(`/agencies/${id}`).then((res) => {
      console.log("dataone ", res.data?.data);
      setIdData(id);

      setValue1(res?.data?.data?.phoneNumbersFirst);
      checkValue1(res?.data?.data?.phoneNumbersFirst);
      formAgencyList.setFieldsValue({
        code: res?.data?.data?.code,
        name: res?.data?.data?.name,
        agencyType: res?.data?.data?.agencyType,
        phoneNumber: res?.data?.data?.phoneNumber,
        taxpayerNumber: res?.data?.data?.taxpayerNumber,
        bankAccount: res.data?.data?.bankAccount,
        bankAccountNumber: res?.data?.data?.bankAccountNumber,
        // copyOfBankAccount: res?.data?.data?.copyOfBankAccount,
        // contractDocument: res?.data?.data?.contractDocument,
        address: res?.data?.data?.address,
      });
      const imageUrl = getFileHostUrl(res?.data?.data?.photoURL);
      console.log("imageUrl", imageUrl);

      const url = getLocalUrl(res?.data?.data?.photoURL);

      console.log("url", url);

      setContactFile([
        {
          uid: "1",
          name: res?.data?.data?.contractDocument,
          status: "done",
          url: imageUrl,
        },
      ]);
      setCopyOfBankAccFile([
        {
          uid: "1",
          name: res?.data?.data?.copyOfBankAccount,
          status: "done",
          url: imageUrl,
        },
      ]);
    });
  };
  const updateData = async (values: any) => {
    console.log("id", idData);
    console.log("values", values);

    await axios.patch(`/agencies/update/${idData}`, {
      code: values?.code,
      name: values?.name,
      agencyType: values?.agencyType,
      phoneNumber: values?.phoneNumber,
      phoneNumbersFirst: valuePhone1,
      taxpayerNumber: values?.taxpayerNumber,
      bankAccount: values?.bankAccount,
      bankAccountNumber: values?.bankAccountNumber,
      address: values?.address,
    });
    const fmData = new FormData();
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };
    if (values.contractDocument) {
      fmData.append(
        "contractDocument",
        values?.contractDocument?.fileList[0]?.originFileObj
      );
    }
    if (values.copyOfBankAccount) {
      fmData.append(
        "copyOfBankAccount",
        values?.copyOfBankAccount?.fileList[0]?.originFileObj
      );
    }
    await axios.patch(`/agencies/upload-file/${idData}`, fmData, config);

    formAgencyList.resetFields();
    setCopyOfBankAccFile([]);
    setContactFile([]);
    setIsOpen(false);
    getData();
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(id);
      },
      width: "fit-content",
    });
  }

  const deleteData = (id: any) => {
    axios.delete(`/agencies/delete/${id}`).then((res) => {
      console.log(res.data);
      setTimeout(() => getData(), 200);
    });
  };

  // const setCreat = () => {
  //   setName("");
  //   setCode("");
  //   setAddress("");
  //   setAgencyType("");
  //   setPhoneNumber("");
  // };

  const set = () => {
    console.log("option =>", option);
  };

  useEffect(() => {
    getData();
    setAgencyTypes();
    setBankName();
  }, []);

  const Onsubmit = (values: any) => {
    // console.log("values", values);
    if (type === "CREATE") {
      creatData(values);
    } else if (type === "UPDATE") {
      updateData(values);
    }
  };
  const onPreview = (file: any) => {
    // console.log("file", file);
    let url = "";
    if (file?.url !== "") {
      url = getLocalUrl(file?.url);
    } else {
      url = getFileHostUrl(file?.name);
    }
    // console.log("url", url);
    window.open(url, "_blank");
  };
  const onRemove = (file: any) => {
    // console.log("file", file);
    // formAgencyList.setFieldsValue({ copyOfBankAccount: [] });
    // setCopyOfBankAccFile([]);
    // setContactFile([]);
  };
  const onchangePage = (pages: any) => {
    setPages(pages);
    getData();
  };
  const onchangePic = (e: any) => {
    // console.log("e change pic contact =>", e.file);
    const { originFileObj } = e.file;
    const url = getLocalUrl(originFileObj);
    setContactFile([
      {
        uid: "1",
        name: e?.file?.name,
        url: url,
      },
    ]);
    // formAgencyList.setFieldsValue({ copyOfBankAccount: "" });
    // setContactFile([]);
  };

  const onchangePic2 = (e: any) => {
    // console.log("e change pic copybank=>", e.file);
    const { originFileObj } = e.file;
    const url = getLocalUrl(originFileObj);
    setCopyOfBankAccFile([
      {
        uid: "1",
        name: e?.file?.name,
        url: url,
      },
    ]);
    // formAgencyList.setFieldsValue({ contractDocument: "" });
    // setCopyOfBankAccFile([]);
  };
  const checkValue1 = (value: any) => {
    // console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue1(body);
      }, 200);
    }
  };
  const onKeydownCheck = (eveb: KeyboardEvent) => {
    console.log("e event", eveb.which);
    if (eveb.which !== 8) {
      eveb.preventDefault();
      // message.error("Please Input Max 10 ");
    }
  };
  return (
    <div>
      <HeaderBar title="AGENCY / AFFILIATION LIST" />
      <Modal
        visible={isOpen}
        footer={null}
        onCancel={() => setIsOpen(false)}
        width={800}
        centered
      >
        <Form form={formAgencyList} onFinish={Onsubmit} layout="vertical">
          <h4>{type} AGENCY AFFILIATION</h4>
          <Row justify="space-around" className="modal-agencyList">
            <Col xs={10} sm={10} md={10} lg={10}>
              <Form.Item
                label="Code"
                name="code"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input></Input>
              </Form.Item>
            </Col>
            <Col xs={10} sm={10} md={10} lg={10}>
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input type="text"></Input>
              </Form.Item>
            </Col>
          </Row>

          <Row justify="space-around" className="modal-agencyList">
            <Col xs={10} sm={10} md={10} lg={10} style={{ paddingTop: "35px" }}>
              <text style={{ color: "#5baea9" }}>
                <text style={{ color: "red" }}>*</text> Agency Type
              </text>
              <Form.Item
                name="agencyType"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optAgentype}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={10} sm={10} md={10} lg={10} style={{ paddingTop: "26px" }}>
              <text style={{ color: "#5baea9" }}>
                <text style={{ color: "red" }}>*</text> Tel.
              </text>
              <Form.Item
                className="selected-countrycode-agency"
                name="phoneNumbersFirst"
                rules={[
                  {
                    required: false,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <ConfigProvider locale={en}>
                  <CountryPhoneInput
                    type="number"
                    value={value1}
                    onChange={(v: any) => {
                      setValue1(v);
                      checkValue1(v);
                    }}
                    onKeyDown={(e: any) => {
                      if (e.target.value.length >= 10) {
                        onKeydownCheck(e);
                      }
                    }}
                  />
                </ConfigProvider>
              </Form.Item>
            </Col>
          </Row>

          <Row className="modal-agencyList">
            <Col offset={1} xs={10} sm={10} md={10} lg={10}>
              <Form.Item
                label="Tax ID Number"
                name="taxpayerNumber"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input type="number"></Input>
              </Form.Item>
            </Col>
          </Row>

          <Row justify="space-around" className="modal-agencyList">
            <Col xs={10} sm={10} md={10} lg={10}>
              <Form.Item
                label="Bank"
                name="bankAccount"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optBanks}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={10} sm={10} md={10} lg={10}>
              <Form.Item
                label="Account Number"
                name="bankAccountNumber"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input type="number" className="input-text"></Input>
              </Form.Item>
            </Col>
          </Row>

          <Row justify="space-around" className="modal-agencyList">
            <Col xs={10} sm={10} md={10} lg={10}>
              <Form.Item
                label="Attach Bank Accounts"
                name="copyOfBankAccount"
                rules={[
                  {
                    required: false,
                    message: "กรุณาอัพโหลดรูป!",
                  },
                ]}
              >
                <Upload
                  maxCount={1}
                  customRequest={({ onSuccess }: any) => {
                    onSuccess();
                  }}
                  onPreview={onPreview}
                  onRemove={onRemove}
                  accept="image/*,.pdf"
                  fileList={contactFile}
                  onChange={(e: any) => onchangePic(e)}
                >
                  <Button
                    icon={<UploadOutlined />}
                    style={{
                      color: "#5baea9",
                      width: "100%",
                      height: "37px",
                      borderColor: "#5BAEA9",
                      borderRadius: "5px",
                    }}
                  >
                    Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col xs={10} sm={10} md={10} lg={10}>
              <Form.Item
                label="Attach Contract"
                name="contractDocument"
                rules={[
                  {
                    required: false,
                    message: "กรุณาอัพโหลดรูป!",
                  },
                ]}
              >
                <Upload
                  maxCount={1}
                  customRequest={({ onSuccess }: any) => {
                    onSuccess();
                  }}
                  onPreview={onPreview}
                  accept="image/*,.pdf"
                  fileList={copyOfBankAccfile}
                  onChange={(e: any) => onchangePic2(e)}
                >
                  <Button
                    icon={<UploadOutlined />}
                    style={{
                      color: "#5baea9",
                      width: "100%",
                      height: "37px",
                      borderColor: "#5BAEA9",
                      borderRadius: "5px",
                    }}
                  >
                    Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          <Row className="modal-agencyList">
            <Col offset={1} xs={22} sm={22} md={22} lg={22}>
              <Form.Item
                name="address"
                label="Address"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <TextArea
                  style={{ width: "100%" }}
                  showCount
                  maxLength={250}
                  placeholder="รายละเอียดที่อยู่"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row className="button-agencyList">
            <Col>
              <Space>
                <Button
                  onClick={() => {
                    setIsOpen(false);
                    formAgencyList.resetFields();
                  }}
                  className="cancleButton-agencyList"
                >
                  ยกเลิก/Cancel
                </Button>
                <Button className="confirmButton-agencyList" htmlType="submit">
                  บันทึกข้อมูล/Submit
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>

      <div style={{ padding: "10px 40px" }}>
        <Row className="button-Create">
          <Button
            onClick={() => {
              setIsOpen(true);
              formAgencyList.resetFields();
              setType("CREATE");
              setContactFile([]);
              setCopyOfBankAccFile([]);
            }}
          >
            <Icon
              icon="ant-design:plus-outlined"
              width="24"
              height="24"
              color="#FFF"
            />
            CREATE AGENCY AFFILIATION
          </Button>
        </Row>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {agencies.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="10%" align="center">
                  {item.code}
                </TableColumn>
                <TableColumn width="15%">{item?.agencyType?.name}</TableColumn>
                <TableColumn width="50%">{item.name}</TableColumn>
                <TableColumn width="12%" align="center">
                  {item?.phoneNumbersFirst?.phone
                    ? "+" +
                      item?.phoneNumbersFirst?.code +
                      item?.phoneNumbersFirst?.phone
                    : item.phoneNumber}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() => {
                      getDataOne(item._id);
                      setIsOpen(true);
                      setType("UPDATE");
                    }}
                  >
                    <Icon
                      icon="el:pencil-alt"
                      width="20"
                      height="20"
                      color="#5BAEA9"
                    />
                  </div>
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <div onClick={() => history.push(`list/${item._id}/member`)}>
                    <Icon
                      icon="fluent:people-list-16-filled"
                      width="20"
                      height="20"
                      color="#5BAEA9"
                    />
                  </div>
                </TableColumn>
                <TableColumn
                  width="5%"
                  align="center"
                  onClick={() => {
                    showDeleteConfirm(item._id, item.name);
                  }}
                >
                  <Icon
                    icon="fa-solid:trash-alt"
                    width="20"
                    height="20"
                    color="#FF6760"
                  />
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
        <Row justify="end" className="pagination-agency">
          <Pagination
            defaultCurrent={pages}
            total={countPages}
            onChange={(e: any) => {
              onchangePage(e);
            }}
          />
        </Row>
      </div>
    </div>
  );
};
export default AgencyList;
